
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class EditIcon extends Vue {
  @Prop({type: String, default: 'white'}) public color!: string;
}
